module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noBroker":"No broker defined"},"fr":{"noBroker":"Aucun référent défini"}}')
  delete Component.options._Ctor
}
